exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-danger[data-v-3676358b]{color:red}", ""]);

// exports
